import {formatHex, interpolate} from 'culori'

// ile drogi od Content Normal do Content Dim przechodzi kolor Name. Grubszy Name w polowie drogi wazy wizualnie
// tyle co reszta komorek - wyroznienie zostaje, masa tekstu maleje. Kontrast na bieli: Lavenda 7,8:1, Grafit 8,4:1
// (reszta komorek 12,3 / 12,7:1). Liczone z palety, wiec dziala w kazdej palecie
const NAME_INK_MIX = 0.5

export function getLightModernNameInkColor(
  contentNormalColor: string,
  contentDimColor: string,
): string {
  return formatHex(interpolate([contentNormalColor, contentDimColor], 'rgb')(NAME_INK_MIX)) ?? ''
}
